module.exports = __webpack_public_path__ + "img/34exp.36368527.jpg";